import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Menu, X, ArrowUpRight } from "lucide-react";
import Logo from "@/components/Logo";
import { scrollToId } from "@/lib/scroll";

const LINKS = [
  ["About", "about"],
  ["My Work", "journey"],
  ["Ventures", "ventures"],
  ["Global Work", "global"],
  ["Search Fund", "search-fund"],
  ["Gallery", "gallery"],
  ["Journal", "journal"],
  ["Contact", "contact"],
];

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    scrollToId(id);
  };

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.9, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
      className={`fixed top-0 left-0 right-0 z-50 transition-[background-color,border-color] duration-500 ${scrolled ? "glass" : "bg-transparent border-b border-transparent"}`}
      data-testid="site-header"
    >
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <div className="flex h-[70px] items-center justify-between">
          <button onClick={() => go("home")} className="flex items-center gap-3 group" data-testid="nav-home-link">
            <Logo size={36} />
            <div className="text-left leading-tight">
              <span className="block font-display text-lg font-semibold text-slate-100 tracking-wide">Bishwa Mohan Pati</span>
              <span className="block font-mono text-[10px] uppercase tracking-[0.28em] text-[#E2C08D]/80">Builder · Connector</span>
            </div>
          </button>
          <nav className="hidden lg:flex items-center gap-7" data-testid="nav-desktop">
            {LINKS.map(([label, id]) => (
              <button key={id} onClick={() => go(id)} data-testid={`nav-${id}-link`} className="text-[13px] font-medium text-slate-300 hover:text-[#E2C08D] transition-colors duration-300 tracking-wide">
                {label}
              </button>
            ))}
            <button onClick={() => go("impact")} data-testid="nav-cta-button" className="group flex items-center gap-1.5 rounded-full border border-[#E2C08D]/40 bg-[#E2C08D]/10 px-4 py-2 text-[13px] font-semibold text-[#E2C08D] hover:bg-[#E2C08D] hover:text-[#0A0C10] transition-colors duration-300">
              Get In Touch <ArrowUpRight size={14} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </button>
          </nav>
          <button className="lg:hidden text-slate-200" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle" aria-label="Menu">
            {open ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>
      {open && (
        <div className="lg:hidden glass border-t border-white/5" data-testid="nav-mobile-menu">
          <div className="px-6 py-4 flex flex-col gap-1">
            {LINKS.map(([label, id]) => (
              <button key={id} onClick={() => go(id)} data-testid={`nav-mobile-${id}-link`} className="text-left py-2.5 text-sm text-slate-300 hover:text-[#E2C08D] border-b border-white/5">
                {label}
              </button>
            ))}
          </div>
        </div>
      )}
    </motion.header>
  );
};

export default Header;
